export const MAIN_HEADER_STYLE = {
    backgroundColor: "#F3F0FF",
    color: "#1D1D1D",
    fontWeight: 600,
    fontSize: "14px",
    borderBottom: "1px solid #E8E4FF"
};

export const SELECT_MENU_PORTAL_STYLES = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
};
